import React from 'react'
import Svg, { SvgType } from 'components/svgComponent/Svg'

export default function(props: SvgType) {
  return (
    <Svg width="42" height="43" viewBox="0 0 42 43" fill="none" {...props}>
      <rect y="0.810059" width="42" height="42" rx="21" fill="#286EFA" />
      <g filter="url(#filter0_d_456_905)">
        <path
          d="M19.2281 29.8101V21.8101H17.2125V19.0601L19.2281 19.0444V17.4351C19.2281 16.3101 19.4365 15.4246 19.8531 14.7788C20.2802 14.133 21.1552 13.8101 22.4781 13.8101H25.2125V16.5757H23.3062C22.7958 16.5757 22.4885 16.6694 22.3844 16.8569C22.2802 17.0444 22.2281 17.3153 22.2281 17.6694V19.0444H25.2437L24.9469 21.8101H22.2281V29.8101H19.2281Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_456_905"
          x="17.2125"
          y="13.8101"
          width="8.03125"
          height="16"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_456_905" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_456_905"
            result="shape"
          />
        </filter>
      </defs>
    </Svg>
  )
}
